import React from 'react';
import { useNavigate } from 'react-router-dom';
import { BilingualText } from '../components/BilingualText';
import { ArrowLeft, Search, Filter, Download, Calendar as CalendarIcon, Clock, ChevronRight } from 'lucide-react';
export function Appointments() {
  const navigate = useNavigate();
  return <div className="min-h-screen bg-slate-50 pb-24" data-id="element-155">
      <header className="bg-white px-4 py-6 border-b border-slate-100 flex items-center justify-between sticky top-0 z-10 lg:px-8" data-id="element-156">
        <div className="flex items-center gap-4" data-id="element-157">
          <button onClick={() => navigate(-1)} className="p-2 -ml-2 text-slate-600 hover:bg-slate-50 rounded-full transition-colors" data-id="element-158">
            <ArrowLeft size={24} data-id="element-159" />
          </button>
          <BilingualText en="Appointments Calendar" ar="تقويم المواعيد" className="text-xl font-bold" data-id="element-160" />
        </div>
        <button className="p-2 text-slate-500 hover:bg-slate-100 rounded-full transition-colors" data-id="element-161">
          <Download size={20} data-id="element-162" />
        </button>
      </header>

      <main className="p-4 lg:p-8 space-y-6 max-w-5xl mx-auto" data-id="element-163">
        <div className="flex flex-col md:flex-row gap-4" data-id="element-164">
          <div className="flex-1 relative" data-id="element-165">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" size={18} data-id="element-166" />
            <input type="text" placeholder="Search by ASN, Supplier or Plate..." className="w-full pl-10 pr-4 py-3 bg-white border border-slate-200 rounded-xl shadow-sm" data-id="element-167" />
          </div>
          <div className="flex gap-2" data-id="element-168">
            <button className="btn-secondary py-3 px-4" data-id="element-169">
              <CalendarIcon size={18} data-id="element-170" />
              <span data-id="element-171">July 11, 2026</span>
            </button>
            <button className="btn-secondary py-3 px-4" data-id="element-172">
              <Filter size={18} data-id="element-173" />
              <span data-id="element-174">Filters</span>
            </button>
          </div>
        </div>

        <div className="space-y-4" data-id="element-175">
          <TimeSlot slot="08:00 AM" appointments={1} data-id="element-176" />
          <TimeSlot slot="09:30 AM" appointments={3} active data-id="element-177" />
          <TimeSlot slot="11:00 AM" appointments={2} data-id="element-178" />
          <TimeSlot slot="01:30 PM" appointments={0} data-id="element-179" />
          <TimeSlot slot="03:00 PM" appointments={1} data-id="element-180" />
        </div>
      </main>
    </div>;
}
function TimeSlot({
  slot,
  appointments,
  active = false
}: any) {
  return <div className="space-y-2" data-id="element-181">
      <div className="flex items-center gap-3 px-2" data-id="element-182">
        <Clock size={16} className="text-slate-400" data-id="element-183" />
        <span className="text-sm font-bold text-slate-500" data-id="element-184">{slot}</span>
        <div className="flex-1 h-px bg-slate-200" data-id="element-185" />
        <span className="text-xs text-slate-400" data-id="element-186">
          {appointments} Appointments
        </span>
      </div>
      {appointments > 0 ? <div className="space-y-2" data-id="element-187">
          {Array.from({
        length: appointments
      }).map((_, i) => <div key={i} className={`card p-4 flex items-center justify-between hover:border-[#2E3192] cursor-pointer transition-all ${active && i === 0 ? 'border-l-4 border-l-[#2E3192]' : ''}`} data-id="element-188">
              <div className="flex items-center gap-4" data-id="element-189">
                <div className="w-10 h-10 rounded-full bg-slate-100 flex items-center justify-center font-bold text-[#2E3192]" data-id="element-190">
                  {String.fromCharCode(65 + i)}
                </div>
                <div data-id="element-191">
                  <div className="font-bold" data-id="element-192">Supplier {i + 1} Logistics</div>
                  <div className="text-xs text-slate-500 flex items-center gap-2" data-id="element-193">
                    <span data-id="element-194">ASN-982{30 + i}</span>
                    <span className="w-1 h-1 bg-slate-300 rounded-full" data-id="element-195" />
                    <span data-id="element-196">Plate: KSA-920{i}</span>
                  </div>
                </div>
              </div>
              <div className="flex items-center gap-3" data-id="element-197">
                <div className={`px-2 py-1 rounded text-[10px] font-bold uppercase ${i === 0 ? 'bg-indigo-100 text-indigo-700' : 'bg-blue-100 text-blue-700'}`} data-id="element-198">
                  {i === 0 ? 'Arrived' : 'Confirmed'}
                </div>
                <ChevronRight size={18} className="text-slate-300" data-id="element-199" />
              </div>
            </div>)}
        </div> : <div className="h-12 border-2 border-dashed border-slate-100 rounded-xl flex items-center justify-center text-slate-300 text-sm italic" data-id="element-200">
          No appointments scheduled
        </div>}
    </div>;
}